export default __webpack_public_path__ + "static/media/474.1dce6ea7.png";